export default __webpack_public_path__ + "static/media/health3.51818d04.jpg";